import classnames from 'classnames';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DropdownContext } from '../Dropdown/DropdownContext';

const DropdownMenu = ({ children, className, tag: Tag, ...props }) => {
  const { isOpen } = useContext(DropdownContext);

  return (
    isOpen && (
      <Tag className={classnames(className, 'dropdown-menu')} data-testid="DropdownMenu" {...props}>
        {children}
      </Tag>
    )
  );
};

DropdownMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

DropdownMenu.defaultProps = {
  children: null,
  className: null,
  tag: 'div',
};

export default DropdownMenu;
